import { Pipe, PipeTransform } from '@angular/core';
import { PhoneNumberFormatService } from '../services/phone-number-format.service';

@Pipe({
    name: 'phoneNumber'
})
export class PhoneNumberPipe implements PipeTransform {

    constructor(private phoneNumberFormatService: PhoneNumberFormatService){}

    transform(value: string, countryCode: string): string {
        if (!value) { return value }

        const phoneNumberFormat = this.phoneNumberFormatService.numberFormatValue;
        let formattedNumber = '';
        let phoneNumber = value ? value.trim() : '';

        if (phoneNumberFormat && phoneNumber) {
            let numberIndex = 0;
            phoneNumber = phoneNumber.replace(/[^a-zA-Z0-9]/g, '');
            for (let i = 0; i < phoneNumberFormat.length; i++) {
                if (phoneNumberFormat[i] === '9') {
                    if (numberIndex < phoneNumber.length) {
                        formattedNumber += phoneNumber[numberIndex];
                        numberIndex++;
                    } else {
                        break; // Stop processing if there are no more digits
                    }
                } else {
                    if (numberIndex < phoneNumber.length) {
                        formattedNumber += phoneNumberFormat[i];
                    } else {
                        break; // Stop adding formatting characters if there are no more digits
                    }
                }
            }

            // Append any remaining numbers from the input
            formattedNumber += phoneNumber.slice(numberIndex);
        } else {
            formattedNumber = phoneNumber;
        }

        return `${countryCode ? `+${countryCode}` : " "} ${formattedNumber}`;
    }
}
